
export class Log {

    id: number;
    utente_test_id: string;
    email_id: string;
    evento: string;
    t_arrivo: number;
    t_apertura: number;
    t_cat: number;
    t_conferma: number;
    q_testo: number;
    cat_scelta: number;
    cat_email: number;
    mouseover_disp: number;
    mouseover_effettuato: number;
    t_screensaver: number;
    token: number;
    premio_sel: number;
    premio_durata: number;
    click_effettuato: number;
}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/_model/Log.ts